import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material'
import React from 'react'

const AccessType = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <FormControl fullWidth>
      <InputLabel>Access Type</InputLabel>
      <Select
        value={moduleValues?.['Access Type'] ?? ''}
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            ['Access Type']: e.target.value,
          }))
        }
        label="Access Type"
      >
        <MenuItem value="IV">Intravenous</MenuItem>
        <MenuItem value="IO">Intraosseous</MenuItem>
      </Select>
    </FormControl>
  </Grid>
)

export default AccessType
